/* eslint-disable no-shadow */
import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  Backdrop,
  ModalWrapper,
  Title,
  TitleText,
  Body,
  SubTitle,
  Note,
  CloseButton,
} from "./styles/performance-info-modal-styles";

export const PerformanceInfoModal = ({ togglePerformanceInfoModal }) => (
  <Backdrop className="animated fadeIn">
    <ModalWrapper className="animated delay-1 fadeInDown">
      <Title>
        <TitleText>Company Performance Metrics</TitleText>
        <CloseButton onClick={() => togglePerformanceInfoModal()}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </Title>
      <Body>
        Ever wondered how we calculate your metrics? You&apos;re about to find
        out...
        <br />
        <br />
        To make the metrics as fair as we can, we only count CVs that have been
        marked as <span>read</span> by employer users. Any CVs that are left{" "}
        <span>unread</span> are not used.
        <SubTitle>Interview Rate</SubTitle>
        To calculate your interview rate, we look at the total number of read
        CVs you&apos;ve submitted and compare that to the number of interviews
        you&apos;ve confirmed.
        <Note>
          Note - if an employer user does not request an interview in the
          correct manner, please ask them to do so using the application
          actions. You cannot confirm an interview unless it is requested
          correctly.
        </Note>
        <SubTitle>Engagements</SubTitle>
        To calculate your engagements, we look at all of the roles you&apos;ve
        engaged on and only count those for which you have submitted a
        candidate.
        <SubTitle>Placements</SubTitle>
        To calculate your placements, we look at all of your candidates and
        count the number of candidates marked as <span>accepted offer</span>.
      </Body>
    </ModalWrapper>
  </Backdrop>
);

PerformanceInfoModal.propTypes = {
  togglePerformanceInfoModal: PropTypes.func.isRequired,
};

export default PerformanceInfoModal;
